import { CdkOverlayOrigin, ConnectedPosition, FlexibleConnectedPositionStrategyOrigin } from '@angular/cdk/overlay';
import { booleanAttribute, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPopoverModule, PopoverPositions } from '@vendasta/galaxy/popover';

export const DEFAULT_TOOLTIP_POSITIONS: ConnectedPosition[] = [PopoverPositions.Top, PopoverPositions.Bottom];

@Component({
  selector: 'glxy-tooltip,',
  templateUrl: './tooltip.component.html',
  host: { class: 'glxy-tooltip' },
  imports: [GalaxyPopoverModule, TranslateModule],
})
export class TooltipComponent {
  /** Origin that references the element the tooltip should be positioned relative to */
  readonly origin = input<CdkOverlayOrigin | FlexibleConnectedPositionStrategyOrigin>();

  /** Optional title for the tooltip */
  readonly title = input<string>();

  /** text that can be added to the tooltip */
  readonly text = input<string>();

  /** Change the background color and text for high contrast with page background */
  readonly highContrast = input(false, { transform: booleanAttribute });

  /** Where the tooltip is allowed to sit relative to its origin */
  readonly positions = input<ConnectedPosition[]>(DEFAULT_TOOLTIP_POSITIONS);

  /** Whether the tooltip is showing */
  readonly show = input(false, { transform: booleanAttribute });

  /* There is nothing to position against until the tooltip has both an origin and something to say. */
  protected readonly popoverOrigin = computed(() => (this.title() || this.text() ? this.origin() : undefined));
}
